import {
  Grid,
  space,
  theme,
  Typography,
} from "@waldner-laboreinrichtungen/component-system";
import { t } from "i18next";
import type { FC } from "react";
import styledComponents from "styled-components";

import type { FunctionGridProps } from "../../partials/function-grid.tsx";
import type { Channel } from "../../view-model.ts";
import {
  getPortValue,
  renderFunction,
} from "../common/function-grid-helpers.tsx";

const StyledGrid = styledComponents(Grid)`
  // grid-template-rows: auto 1fr 1fr;
  height: 100%;
`;

const StyledGroupContainer = styledComponents.div`
  border: 1px solid ${theme.colorPalette.grey200};
  border-radius: ${theme.borderRadius.default};
  padding: ${space(4)} ${space(2)} ${space(2)} ${space(2)};
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledGroupHeader = styledComponents(Typography)`
  position: absolute;
  top: 0;
  right: ${space(4)};
  transform: translateY(-50%);
  background: #fff;
  padding: 0 ${space(3)};
  z-index: 1;
`;

const StyledGroupColumn = styledComponents(Grid.Column)`
  grid-row: span 2;
`;

const StyledInnerGrid = styledComponents(Grid)`
  flex: 1;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: ${space(2)};
  grid-column-gap: 0;
  height: 100%;
`;

type SpherePort = "left" | "right";

function getPort(channel: Channel): SpherePort | undefined {
  return getPortValue(channel, ["left", "right"]);
}

export const FunctionGrid: FC<FunctionGridProps> = ({
  functions,
  incidents,
  onSelect,
}) => {
  const leftFunctions = functions.filter((f) => getPort(f) === "left");
  const rightFunctions = functions.filter((f) => getPort(f) === "right");
  const ungroupedFunctions = functions.filter((f) => {
    const port = getPort(f);
    return port !== "left" && port !== "right";
  });
  return (
    <StyledGrid columnGap={space(1)} rowGap={space(3)}>
      <Grid.Column key="main" width={12}>
        <Grid>
          {ungroupedFunctions.map((channel) =>
            renderFunction(channel, onSelect, 3, incidents)
          )}
        </Grid>
      </Grid.Column>
      <StyledGroupColumn key="left" width={6}>
        <StyledGroupContainer>
          <StyledGroupHeader>
            <Typography color="grey500" size="lg" weight="medium">
              {t("channel.left")}
            </Typography>
          </StyledGroupHeader>
          <StyledInnerGrid>
            {leftFunctions.map((channel) =>
              renderFunction(channel, onSelect, 6, incidents)
            )}
          </StyledInnerGrid>
        </StyledGroupContainer>
      </StyledGroupColumn>
      <StyledGroupColumn key="right" width={6}>
        <StyledGroupContainer>
          <StyledGroupHeader>
            <Typography color="grey500" size="lg" weight="medium">
              {t("channel.right")}
            </Typography>
          </StyledGroupHeader>
          <StyledInnerGrid>
            {rightFunctions.map((channel) =>
              renderFunction(channel, onSelect, 6, incidents)
            )}
          </StyledInnerGrid>
        </StyledGroupContainer>
      </StyledGroupColumn>
    </StyledGrid>
  );
};
